import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, isRef as _isRef, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withKeys as _withKeys, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/eye-view.svg'
import _imports_1 from '@/assets/img/view-streamline.svg'
import _imports_2 from '@/assets/img/view-off-streamline.svg'


const _withScopeId = n => (_pushScopeId("data-v-25ca7703"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page overflow-x-hide overflow-y-hide" }
const _hoisted_2 = { class: "container no-padding" }
const _hoisted_3 = { class: "row no-margin tw-relative" }
const _hoisted_4 = { class: "col-md-12 flex-container" }
const _hoisted_5 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-body-sec1" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  for: "id",
  class: "control-label input-label-form"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = ["v-if"]
const _hoisted_13 = {
  for: "id",
  class: "control-label input-label-form"
}
const _hoisted_14 = { class: "password-sec" }
const _hoisted_15 = ["type", "onKeyup"]
const _hoisted_16 = {
  key: 0,
  class: "tw-h-[40px]",
  src: _imports_0
}
const _hoisted_17 = {
  key: 1,
  class: "tw-h-[40px]",
  src: _imports_1
}
const _hoisted_18 = {
  key: 2,
  class: "tw-h-[40px] tw-mb-[2px]",
  src: _imports_2
}
const _hoisted_19 = ["v-if"]
const _hoisted_20 = { class: "login-btn" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = { class: "modal-sec6" }
const _hoisted_24 = { class: "modal-sec6-sec1" }

import $ from "jquery";
import userService from "@/services/user/userService";
import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils, { passwordHash } from "@/utils/utilities";
import { load } from "recaptcha-v3";
import VRuntimeTemplate from "vue3-runtime-template";
import store from "@/store";
import { UserRoute } from "@/services/apiRoutes/routes";
import {
  localStorageBoolean,
  localStorageKey,
  MFAStatus,
} from "@/utils/constants";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import router from "@/router";
import HeaderLogo from "@/components/common/headerLogoWithoutLangPicker.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern.vue";
import {
  startRegistration,
  startAuthentication,
} from "@simplewebauthn/browser";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props, { expose: __expose }) {

let dyn_height = ref("");
const disableButton = ref(true);
let windowHeight = ref("");
let showPassword = ref(false);
let enable_showpassword = ref(false);
const showProspectCallbackError = ref(false);
const prospectCallbackErrorMsg = ref("");
const loginData = ref({ username: "", password: "" });
let loginErrorMsg = ref("");
const emailFieldFocus = ref(0);

let userPlaceholder = ref("");
const footerTextTags: any = {
  "app-nav-cyber-system-text": { openTag: "<strong>", closeTag: "</strong>" },
  "app-user-login-help-link-1": {
    openTag: '<a href="javascript:void(0)">',
    closeTag: "</a>",
  },
};

let footerText = ref("");
const loginModal = ref<null>(null);
const passwordFieldType = ref("password");

const languageSelected = computed(
  () => store.state.LanguagePicker.languageSelected,
);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const passwordIV = computed(() => store.state.LanguagePicker.pwdFeIv);

const checkFormVals = () => {
  if (
    loginData.value.username === "" ||
    loginData.value.password === "" ||
    emailValid.value === false
  ) {
    disableButton.value = true;
  } else {
    disableButton.value = false;
  }
};

const getUiText = (id: string, isArray = false) => {
  return Utils.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const getProcessedUIText = (id: string, tags: any) => {
  return Utils.getProcessedUIText(
    id,
    tags,
    languageSelectedText.value,
    defaultUiText.value,
  );
};

const updateUIVariables = () => {
  userPlaceholder.value = getUiText("app-user-login-username-prompt-1");
  footerText.value =
    "<span>" +
    getProcessedUIText("app-user-login-help-text-1", footerTextTags) +
    "</span>";
};

const username: any = ref();
const onResize = () => {
  dyn_height.value = (window.innerHeight + "px") as string;
  windowHeight.value = "" + window.innerHeight + "px !important ";
  username.value && username.value.focus();
};

const password = ref();
const togglePassword = () => {
  if (!enable_showpassword.value) return;
  showPassword.value = !showPassword.value;

  passwordFieldType.value =
    password.value.type === "password" ? "text" : "password";
};
const emailValid = ref(true);
const emailValidationMsg = ref("");
const inputBlur = (inputIs: string, isBlur = false, val) => {
  if (isBlur) {
    emailFieldFocus.value++;
  }
  if (inputIs === "EMAIL" && emailFieldFocus.value > 0) {
    if (!Utils.IsEmailValid(isBlur ? loginData.value.username : val)) {
      emailValid.value = false;
      emailValidationMsg.value = getUiText("app-prospect-error-invalid-email");
    } else {
      emailValid.value = true;
      emailValidationMsg.value = "";
    }
  }
  checkFormVals();
};

const setLanguages = async () => {
  await Utils.getV3Recaptcha().then(
    async (finalKey: any) => {
      localStorage.removeItem("csrfReloadDone");
      const recaptcha = await load(`${finalKey}`, {
        autoHideBadge: true,
      });
      recaptcha.execute("submit").then((token) => {
        localStorage.setItem(localStorageKey.recaptcha, token);
        store.dispatch("LanguagePicker/setLanguages", token);
      });
      recaptcha.execute("submit").then((token) => {
        localStorage.setItem(localStorageKey.recaptcha, token);
        store.dispatch("LanguagePicker/setLanguageList", token);
      });
    },
    (error: any) => {
      if (error && error.data && error.data.error && error.data.error.type) {
        if (error.data.error.type === "exc_session_invalid-1") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data.error),
          );
          router.push({ path: "/" });
        } else {
          showErrorInfo(error.data.error);
        }
      } else if (error.data.message === "invalid csrf token") {
        if (localStorage.getItem("csrfReloadDone") == null) {
          localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
          router.go(0);
        }
        sessionStorage.setItem(
          "prospectCallbackErrorInfo",
          JSON.stringify(error.data),
        );
        router.push({ path: "/" });
      } else {
        showErrorInfo(error.data);
      }
    },
  );
};

const keyMonitor = () => {
  loginErrorMsg.value = "";
  const myInput: any = document.getElementById("psw");
  enable_showpassword.value = myInput.value.length > 0 ? true : false;
};

const showErrorInfo = (errorInfo: any) => {
  if (errorInfo && errorInfo !== "") {
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showProspectCallbackError.value = true;
      prospectCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const resetShowProspectCallbackError = () => {
  showProspectCallbackError.value = false;
  prospectCallbackErrorMsg.value = "";
};

const forgotPassword = () => {
  router.push(UserRoute.forgotPassword);
};

const submit = async () => {
  if (!enable_showpassword.value) return;

  const passwordValue = await passwordHash(
    loginData.value.password,
    passwordIV.value,
  );

  const formData = {
    email: loginData.value.username,
    password: `%s${passwordIV.value}.${passwordValue}`,
  };

  userService.login(formData).then(
    async (res: any) => {
      localStorage.removeItem("csrfReloadDone");
      localStorage.removeItem(localStorageKey.currentOrgData);
      localStorage.removeItem(localStorageKey.currentUserData);
      if (window.innerWidth > 768) {
        store.dispatch("Navigation/setMenuOpen");
        store.dispatch("Navigation/setChevronActive", true);
      }
      if (res.data.data.mfaStatus === MFAStatus.NOT_REQUIRED) {
        await Utils.afterLoginActions(res.data.data);
      } else if (res.data.data.mfaStatus === MFAStatus.REGISTERED) {
        store.dispatch("User/setPreSession");
        router.push(UserRoute.twoStepAuthentication);
      } else if (res.data.data.mfaStatus === MFAStatus.NOT_REGISTERED) {
        router.push(UserRoute.mfaSelection);
      } else if (
        res.data.data.mfaStatus === MFAStatus.REGISTERED_PK ||
        res.data.data.mfaStatus === MFAStatus.REGISTERED_PKONLY
      ) {
        const isTotpRegistered =
          res.data.data.mfaStatus === MFAStatus.REGISTERED_PK ? true : false;
        webAuthnVerify(isTotpRegistered);
      }
    },
    (error: any) => {
      if (error && error.data && error.data.error && error.data.error.type) {
        if (error.data.error.type === "exc_session_invalid-1") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data.error),
          );
          router.push({ path: "/" });
        } else if (error.data.error.type === "exc_auth_perm-2") {
          loginErrorMsg.value = getUiText("app-login-credentials-error-1");
        } else {
          if (error.data.error.id === "email") {
            emailValid.value = false;
            emailValidationMsg.value = getUiText(
              "app-prospect-error-invalid-email",
            );
            disableButton.value = true;
          } else {
            loginErrorMsg.value =
              error.data?.error?.message ||
              getUiText("app-login-credentials-error-1");
          }
        }
      } else {
        if (
          error &&
          error.data &&
          error.data.message &&
          error.data.message === "invalid csrf token"
        ) {
          if (localStorage.getItem("csrfReloadDone") == null) {
            let temp = { message: "Please try again" };
            localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
            showErrorInfo(temp);
            router.go(0);
          }
        }
        showErrorInfo(error.data);
      }
    },
  );
};

const webAuthnVerify = (isTotpRegistered = false) => {
  userService
    .mfaWebauthnAuthenticate()
    .then(async (res: any) => {
      try {
        const challengeResponse = res.data.data;
        const attResp = await startAuthentication(challengeResponse);
        userService
          .mfaWebauthnVerifyAuthentication(attResp)
          .then(async (res: any) => {
            if (res && res.status && res.status === 200 && res.data) {
              await Utils.afterLoginActions(res.data.data);
            }
          });
      } catch (err) {
        store.dispatch("User/setPreSession");
        if (isTotpRegistered) router.push(UserRoute.twoStepAuthentication);
      }
    })
    .catch((err: any) => {
      if (isTotpRegistered) {
        store.dispatch("User/setPreSession");
        router.push(UserRoute.twoStepAuthentication);
      }
    });
};

onBeforeUnmount(() => {
  const body = $("body");
  if (body.hasClass("page-opacity")) {
    body.removeClass("page-opacity page-bg page-shadow");
  }
});
const route = useRoute();
onMounted(() => {
  const email = route.query.email;
  if (email) {
    loginData.value.username = email as string;
  }
  nextTick(function () {
    window.addEventListener("resize", onResize);
    onResize();
  });
  // (loginModal as any).modal("show");
  document.getElementById("loginModal")?.classList.add("show");
  const body = $("body");
  if (!body.hasClass("page-opacity")) {
    body.addClass("page-opacity page-bg");
  }
  setLanguages();
  updateUIVariables();
});

watch(
  () => loginData.value.username,
  () => {
    checkFormVals();
  },
  { deep: true },
);

watch(
  () => loginData.value.password,
  () => {
    checkFormVals();
  },
  { deep: true },
);

watch(
  () => languageSelected,
  () => {
    updateUIVariables();
  },
  { deep: true },
);

__expose({ submit });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "col-md-12",
          style: _normalizeStyle({ 'min-height': _unref(dyn_height) })
        }, [
          _createVNode(HeaderLogo, {
            "page-type": '3',
            light_logo: true
          }),
          _createElementVNode("div", {
            class: "row no-padding main-body h-100",
            style: _normalizeStyle({ height: _unref(windowHeight) })
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(BrandPattern, {
                page: "LOGIN",
                top: 72
              })
            ])
          ], 4)
        ], 4),
        (showProspectCallbackError.value || null)
          ? (_openBlock(), _createBlock(errorhandler, {
              key: 0,
              "prospect-callback-error-msg": prospectCallbackErrorMsg.value,
              onResetShowProspectCallbackError: resetShowProspectCallbackError
            }, null, 8, ["prospect-callback-error-msg"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: "loginModal",
          ref_key: "loginModal",
          ref: loginModal,
          class: "modal fade login-modal show tw-block",
          role: "dialog",
          "aria-labelledby": "loginModalLabel",
          "data-backdrop": "false"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(getUiText("app-user-login-heading-1")), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(getUiText("app-user-login-username-heading-1")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "username",
                    ref_key: "username",
                    ref: username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginData.value.username) = $event)),
                    "data-cy": "usr",
                    type: "username",
                    class: _normalizeClass([!emailValid.value ? 'invalid-input' : '', "form-control form-control-lg password-input username-input"]),
                    tabindex: "0",
                    placeholder: _unref(userPlaceholder),
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (inputBlur('EMAIL', true))),
                    onInput: _cache[2] || (_cache[2] = 
                      (e) => {
                        _isRef(loginErrorMsg) //@ts-ignore
 ? loginErrorMsg.value = '' : loginErrorMsg = '';
                        inputBlur('EMAIL', false, e.target?.value || '');
                      }
                    )
                  }, null, 42, _hoisted_11), [
                    [_vModelText, loginData.value.username]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["error-msg", !emailValid.value ? 'mg-top-19' : '']),
                    "v-if": !emailValid.value || null
                  }, [
                    _createElementVNode("span", null, _toDisplayString(emailValidationMsg.value), 1)
                  ], 10, _hoisted_12),
                  _createElementVNode("label", _hoisted_13, _toDisplayString(getUiText("app-user-login-password-heading-1")), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      id: "psw",
                      ref_key: "password",
                      ref: password,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loginData.value.password) = $event)),
                      "data-cy": "psw",
                      type: passwordFieldType.value,
                      class: "form-control form-control-lg password-input",
                      onKeyup: _withKeys(submit, ["enter"]),
                      onInput: keyMonitor
                    }, null, 40, _hoisted_15), [
                      [_vModelDynamic, loginData.value.password]
                    ]),
                    _createElementVNode("span", {
                      tabindex: "0",
                      class: "show-password pr-3",
                      onClick: togglePassword
                    }, [
                      (!_unref(enable_showpassword) || null)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                        : (_unref(enable_showpassword) && !_unref(showPassword))
                          ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                          : (_unref(enable_showpassword) && _unref(showPassword))
                            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                            : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        id: "show-psw",
                        class: _normalizeClass(["show-password-label", _unref(enable_showpassword) ? 'enabled' : 'disabled'])
                      }, _toDisplayString(!_unref(showPassword)
                            ? getUiText("app-user-login-password-show-1")
                            : getUiText("app-user-login-password-hide-1")), 3)
                    ])
                  ]),
                  _createElementVNode("div", {
                    id: "error-msg",
                    class: _normalizeClass(["error-msg", _unref(loginErrorMsg) ? 'mg-top-25' : '']),
                    "data-cy": "signin-error",
                    "v-if": _unref(loginErrorMsg) !== '' || null
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(loginErrorMsg)), 1)
                  ], 10, _hoisted_19)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    id: "signin-button",
                    "data-cy": "signin-button",
                    type: "button",
                    class: _normalizeClass(`btn btn-primary signin-button ${
                      passwordIV.value === ''
                        ? 'tw-cursor-not-allowed tw-pointer-events-none'
                        : ''
                    }`),
                    disabled: disableButton.value,
                    onClick: submit
                  }, _toDisplayString(getUiText("app-user-login-button-signin-1")), 11, _hoisted_21),
                  _createElementVNode("a", {
                    class: "forgot-text-button",
                    "data-cy": "login-page-forgot-password-button",
                    tabindex: "0",
                    onClick: forgotPassword
                  }, _toDisplayString(getUiText("app-user-login-password-forgotten-link-1")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(VRuntimeTemplate), { template: _unref(footerText) }, null, 8, ["template"])
                  ])
                ])
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ]))
}
}

})